import { render, staticRenderFns } from "./AlarmSidebar.vue?vue&type=template&id=2b991f31"
import script from "./AlarmSidebar.vue?vue&type=script&lang=js"
export * from "./AlarmSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports